import { text, index, uniqueIndex } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'

// ============================================================================
// connectors_oauth_states — Ephemeral PKCE / CSRF state for the OAuth flow
//
// Rows are short-lived (expires_at ~10 min). A background sweeper deletes
// expired rows; `state` is unique so callbacks can O(1) match + drop.
// ============================================================================
export const connectorOauthStates = defineTable(
  'connectors',
  'oauth_states',
  {
    id: text('id').primaryKey(),
    companyId: text('company_id').notNull(),
    typeId: text('type_id').notNull(),
    state: text('state').notNull(),
    codeVerifier: text('code_verifier').notNull(),
    redirectAfter: text('redirect_after'),
    userId: text('user_id'),
    expiresAt: text('expires_at').notNull(),
    createdAt: text('created_at').notNull(),
  },
  (table) => [
    uniqueIndex('connectors_oauth_states_state_unique').on(table.state),
    index('connectors_oauth_states_expires_at_idx').on(table.expiresAt),
    index('connectors_oauth_states_company_expires_idx').on(table.companyId, table.expiresAt),
  ],
)

export type ConnectorOauthState = typeof connectorOauthStates.$inferSelect
export type NewConnectorOauthState = typeof connectorOauthStates.$inferInsert
